import { uploadImage } from './imageUpload';

export async function uploadUserAvatar(params: {
  userId: string;
  file: File;
}): Promise<string> {
  const { userId, file } = params;

  if (!userId) {
    throw new Error('Missing userId for avatar upload');
  }

  if (!file || !file.type?.startsWith('image/')) {
    throw new Error('Selected file is not a valid image');
  }

  const version = Date.now();

  return await uploadImage(file, `avatars/${userId}/avatar-${version}.jpg`, {
    maxSizeMB: 0.8,
    maxDim: 512,
    contentType: 'image/jpeg',
  });
}